import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import moment from "moment";
// import { Bank, GST } from "../../../exports/Images";
// import { Button } from "react-bootstrap";
// import AddBankAccount from "./banks/AddBankAccount";
import { fetchAllGymsData } from "../../../redux/reducers/apiSlice";
import ModalHeadAndClose from "../common/ModalHeadAndClose";
import PaginatedTable from "../../components-bootstrap/PaginatedTable";
import SelectDropdown from "../../components-react/SelectDropdown";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
// import { decryptedText } from "../../../data/DecrytedDatas";
import SettlementGraph from "./SettlementGraph";
import AllBankDetails from "./banks/AllBankDetails";
import { selectAuth } from "../../auth/auth.selector";

function LSGBcards({ allSettlementData }) {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { allGymsGstIncludedData } = useSelector((state) => state.api);
  const gymData = useSelector(selectGymData);

  // const [showAddbankModal, setShowAddbankModal] = useState(false);
  const [bankDetailsAvailable, setBankDetailsAvailable] = useState({
    bankDetailsModal: false,
    bankDetails: {},
  });
  const [allGymsData, setAllGymsData] = useState([]);
  const [bankDetailsModal, setBankDetailsModal] = useState(false);
  const [selectedGymId, setSelectedGymId] = useState("");

  const [isPaginationPaymentLinks, setPaginationPaymentLinks] = useState([]);
  const [isPagePaymentLinks, setIsPagePaymentLinks] = useState(0);
  const [rowsPerPagePaymentLinks, setRowsPerPagePaymentLinks] = useState(10);

  const cardData = allSettlementData?.[0] || {};

  const selectedGymQueryParam =
    decryptedText?.account_type === "gym" ||
    decryptedText?.account_type === "receptionist"
      ? `gym_id=${decryptedText?.gym_id || decryptedText?.uid}`
      : selectedGymId
      ? `gym_id=${selectedGymId?.value}`
      : "";

  useEffect(() => {
    dispatch(
      fetchAllGymsData({
        page: isPagePaymentLinks + 1,
        gymid: selectedGymQueryParam,
        token: decryptedText?.token,
      })
    );
  }, [isPagePaymentLinks, selectedGymQueryParam]);

  useEffect(() => {
    if (allGymsGstIncludedData?.status && allGymsGstIncludedData?.data) {
      setAllGymsData(allGymsGstIncludedData?.data);
      setPaginationPaymentLinks(allGymsGstIncludedData?.pagination);
    }
  }, [allGymsGstIncludedData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  const gstTableColumnValues = [
    {
      dataField: "gym_name",
      text: "Gym name",
      formatter: (cell, row) => (
        <span className="tdBolder">
          {row.gym_name && row.gym_name !== "null" ? row.gym_name : "NA"}
        </span>
      ),
    },
    {
      dataField: "name",
      text: "Beneficiary Name",
      formatter: (cell, row) => (
        <span className="tdBolder">
          {row.name && row.name !== "null" ? row.name : "NA"}
        </span>
      ),
    },
    {
      dataField: "bank_name",
      text: "Bank name",
      formatter: (cell, row) => (
        <span className="tdBolder">
          {row.bank_name && row.bank_name !== "null" ? row.bank_name : "NA"}
        </span>
      ),
    },
    {
      dataField: "account_number",
      text: "Account Number",
      formatter: (cell, row) => (
        <span className="tdBolder">
          {row.account_number && row.account_number !== "null"
            ? row.account_number
            : "-"}
        </span>
      ),
    },
    {
      dataField: "ifsc_code",
      text: "IFSC Code",
      formatter: (cell, row) => (
        <span className="tdBolder">
          {row.ifsc_code && row.ifsc_code !== "null" ? row.ifsc_code : "-"}
        </span>
      ),
    },
    {
      dataField: "gst_number",
      text: "GST Number",
      formatter: (cell, row) => (
        <span className="tdBolder">
          {row.gst_number &&
          row.gst_number !== "null" &&
          row.gst_number !== "N/A"
            ? row.gst_number
            : "Not Available"}
        </span>
      ),
    },
  ];

  return (
    <div className="lsbCardsContainer">
      <>
        {/* <Modal
        isOpen={showAddbankModal}
        onRequestClose={() => setShowAddbankModal(false)}
        contentLabel="Settlement Modal"
        ariaHideApp={false}
      >
        <AddBankAccount onClose={() => setShowAddbankModal(false)} />
      </Modal>

      <Modal
        isOpen={bankDetailsModal}
        onRequestClose={() => setBankDetailsModal(false)}
        contentLabel="Bank Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer gstTable">
          <ModalHeadAndClose
            title=""
            onClose={() => setBankDetailsModal(false)}
          />

          <div className="commonWrapper">
            <SelectDropdown
              options={gymData}
              selectedOption={selectedGymId}
              setSelectedOption={(selectedValue) =>
                setSelectedGymId(selectedValue)
              }
              name="Gym"
            />
          </div>

          <PaginatedTable
            columnsValues={gstTableColumnValues}
            dataValues={allGymsData}
            paginationTotalData={isPaginationPaymentLinks}
            paginationPageNumber={isPagePaymentLinks}
            setPaginationPageNumber={setIsPagePaymentLinks}
            paginationRowsPerPage={rowsPerPagePaymentLinks}
            setPaginationRowsPerPage={setRowsPerPagePaymentLinks}
          />
        </div>
      </Modal> */}
      </>

      <Modal
        isOpen={bankDetailsModal}
        onRequestClose={() => setBankDetailsModal(false)}
        contentLabel="Bank Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer gstTable">
          <ModalHeadAndClose
            title=""
            onClose={() => setBankDetailsModal(false)}
          />

          <div className="commonWrapper">
            <SelectDropdown
              options={gymData}
              selectedOption={selectedGymId}
              setSelectedOption={(selectedValue) =>
                setSelectedGymId(selectedValue)
              }
              name="Gym"
            />
          </div>

          <PaginatedTable
            columnsValues={gstTableColumnValues}
            dataValues={allGymsData}
            paginationData={isPaginationPaymentLinks}
            isPage={isPagePaymentLinks}
            setIsPage={setIsPagePaymentLinks}
          />
        </div>
      </Modal>

      <div className="erpCardsContainer">
        <div className="erpCard">
          <div className="erpNetRevenue">
            <span className="labelname">Net Revenue</span>
            <span className="labelNameSmall">
              {(cardData?.date_from &&
                moment(cardData?.date_from)
                  .tz("Asia/Kolkata")
                  .format("DD MMMM YYYY")) ||
                "-"}
            </span>
            <div className="transactionIdAmount">
              <h3 className="net">₹{cardData?.net_revenue || 0}</h3>

              <div className="transaction">
                <span className="labelname">Gym Name</span>
                <span className="labelNameSmall">
                  {cardData?.gym_name || "-"}
                </span>
              </div>
            </div>
          </div>
          <div className="erpLists">
            <span className="tagline">Recent</span>
            <div className="erpListBox">
              <div className="iconAndLabel lsgbTransactonDateId">
                <p className="name">
                  {(allSettlementData?.[1]?.date_from &&
                    moment(allSettlementData?.[1]?.date_from)
                      .tz("Asia/Kolkata")
                      .format("DD MMMM YYYY")) ||
                    "-"}
                </p>
                <span className="transactionid">
                  {allSettlementData?.[1]?.gym_name || "-"}
                </span>
              </div>
              <p className="amount">
                ₹{allSettlementData?.[1]?.net_revenue || 0}
              </p>
            </div>
            <div className="erpListBox">
              <div className="iconAndLabel lsgbTransactonDateId">
                <p className="name">
                  {(allSettlementData?.[2]?.date_from &&
                    moment(allSettlementData?.[2]?.date_from)
                      .tz("Asia/Kolkata")
                      .format("DD MMMM YYYY")) ||
                    "-"}
                </p>
                <span className="transactionid">
                  {allSettlementData?.[2]?.gym_name || "-"}
                </span>
              </div>
              <p className="amount">
                ₹{allSettlementData?.[2]?.net_revenue || 0}
              </p>
            </div>
            <div className="erpListBox">
              <div className="iconAndLabel lsgbTransactonDateId">
                <p className="name">
                  {(allSettlementData?.[3]?.date_from &&
                    moment(allSettlementData?.[3]?.date_from)
                      .tz("Asia/Kolkata")
                      .format("DD MMMM YYYY")) ||
                    "-"}
                </p>
                <span className="transactionid">
                  {allSettlementData?.[3]?.gym_name || "-"}
                </span>
              </div>
              <p className="amount">
                ₹{allSettlementData?.[3]?.net_revenue || 0}
              </p>
            </div>
          </div>
        </div>

        <div className="erpCard">
          <SettlementGraph />
        </div>

        {!bankDetailsAvailable?.bankDetailsModal && (
          <div className="erpCard">
            <div className="settlementGraphContainer">
              <div className="settleGraphTitleAndFilter">
                <h5 className="tite">Bank Details</h5>
                <button
                  className="viewAllBtn"
                  onClick={() => setBankDetailsModal(true)}
                >
                  View All
                </button>
              </div>

              <div className="erpLists scrollableMiniContainer">
                <AllBankDetails
                  allGymsData={allGymsData}
                  setBankDetailsAvailable={setBankDetailsAvailable}
                />
              </div>
            </div>
          </div>
        )}

        {bankDetailsAvailable?.bankDetailsModal && (
          <div className="erpCard bankDetailsCard">
            {/* <div className="gstNoContainer">
              <div className="gstImage">
                <div className="gstIconContainer">
                  <img src={GST} alt="GST" />
                </div>
                <span className="gstName">GST Number</span>
              </div>
              |<span className="gstNo">2DSA02ADA8FAGH</span>
            </div> */}

            <h5 className="bankDetailsHeadline">Bank details</h5>

            <div className="bankDetailsContainer">
              <div className="bankDetails">
                <div className="whiteLine"></div>
                <div className="bankDetailsData">
                  <div className="headAndData">
                    <span className="headline">Beneficiary Name</span>
                    <span className="datavalue">
                      {bankDetailsAvailable.bankDetails?.name &&
                      bankDetailsAvailable.bankDetails?.name !== "null"
                        ? bankDetailsAvailable.bankDetails.name
                        : "-"}
                    </span>
                  </div>
                  <div className="headAndData">
                    <span className="headline">Bank Name</span>
                    <span className="datavalue">
                      {bankDetailsAvailable.bankDetails?.bank_name &&
                      bankDetailsAvailable.bankDetails?.bank_name !== "null"
                        ? bankDetailsAvailable.bankDetails.bank_name
                        : "-"}
                    </span>
                  </div>
                  <div className="headAndData">
                    <span className="headline">Account Number</span>
                    <span className="datavalue">
                      {bankDetailsAvailable.bankDetails?.account_number &&
                      bankDetailsAvailable.bankDetails?.account_number !==
                        "null"
                        ? bankDetailsAvailable.bankDetails.account_number
                        : "-"}
                    </span>
                  </div>
                  <div className="headAndData">
                    <span className="headline">IFSC Code</span>
                    <span className="datavalue">
                      {bankDetailsAvailable.bankDetails?.ifsc_code &&
                      bankDetailsAvailable.bankDetails?.ifsc_code !== "null"
                        ? bankDetailsAvailable.bankDetails.ifsc_code
                        : "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="showLessbtnContainer">
              <button
                className="showLessbtn"
                onClick={() =>
                  setBankDetailsAvailable({
                    bankDetailsModal: false,
                    bankDetails: {},
                  })
                }
              >
                Show Less
              </button>
            </div>
          </div>
        )}

        <>
          {/* <div className="erpCard bankDetailsCard">
          <div
            className="gstNoContainer"
            onClick={() =>
              decryptedText?.account_type === "gym"
                ? setBankDetailsModal(false)
                : setBankDetailsModal(true)
            }
            style={{ cursor: "pointer" }}
          >
            <div className="gstImage">
              <div className="gstIconContainer">
                <img src={GST} alt="GST" />
              </div>
              <span className="gstName">GST Number</span>
            </div>
            |
            <span className="gstNo">
              {decryptedText?.account_type === "gym"
                ? allGymsData?.[0]?.gst_number || "No GST Available"
                : "Gyms GST"}
            </span>
          </div>

          <div className="bankDetailsContainer addBankdetails">
            <img src={Bank} alt="Add Bank Details" />
            <Button variant="danger" onClick={() => setShowAddbankModal(true)}>
              + Add Bank Account
            </Button>
          </div>
        </div> */}
        </>
      </div>
    </div>
  );
}

export default LSGBcards;
